/**
 * Format number with Indian locale commas
 */
export const formatNumberWithCommas = (number) => {
  return number ? number.toLocaleString('en-IN') : '0';
};

/**
 * Trim and format user name for display
 */
export const trimUserName = (user) => {
  if (!user) return '';
  
  let formattedUser = user.toLowerCase().trim();
  if (formattedUser.length > 0) {
    formattedUser = formattedUser.charAt(0).toUpperCase() + formattedUser.slice(1);
    const spaceIndex = formattedUser.indexOf(' ');
    if (spaceIndex > -1 && formattedUser.length > spaceIndex + 1) {
      formattedUser = formattedUser.substring(0, spaceIndex + 1) + '*'.repeat(0);
    }
  }
  if (formattedUser.length > 20) {
    return formattedUser.slice(0, 20) + '...';
  }
  return formattedUser;
};

/**
 * Get today's date string in YYYY-MM-DD format
 */
export const getTodayDateString = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Calculate remaining time until target date
 */
export const calculateRemainingTime = (targetDate) => {
  const now = new Date();
  const difference = targetDate - now;
  
  if (difference < 0) {
    return { hours: 0, minutes: 0, seconds: 0, days: 0 };
  }
  
  const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((difference % (1000 * 60)) / 1000);
  
  return { hours, minutes, seconds, days };
};

/**
 * Calculate daily deals timer (time until tomorrow midnight)
 */
export const calculateDailyDealsTimer = () => {
  const now = new Date();
  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);
  const difference = tomorrow - now;
  
  if (difference < 0) {
    return { hours: 0, minutes: 0, seconds: 0 };
  }
  
  const hours = Math.floor(difference / (1000 * 60 * 60));
  const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((difference % (1000 * 60)) / 1000);
  
  return { hours, minutes, seconds };
};

/**
 * Format timer display
 */
export const formatTimerDisplay = (time) => {
  if (!time || time.days === undefined) return '00:00:00';
  
  if (time.days > 2) {
    return `${time.days} days left`;
  }
  
  const totalHours = time.days * 24 + time.hours;
  return `${String(totalHours).padStart(2, '0')}:${String(time.minutes).padStart(2, '0')}:${String(time.seconds).padStart(2, '0')}`;
};

/**
 * Get card action handler based on card type and payment status
 */
export const getCardAction = (cardType, cardPaymentStatus) => {
  if (cardType === 'ELITE') {
    return 'loadCard';
  } else if (cardType === 'INTRO' && cardPaymentStatus) {
    return 'upgradeCard';
  } else if (cardType === 'INTRO' && !cardPaymentStatus) {
    return 'purchaseCard';
  } else if (cardType === 'NOCARD') {
    return 'activateCard';
  }
  return 'upgradeCard';
};

/**
 * Get button text based on card type and payment status
 */
export const getButtonText = (cardType, cardPaymentStatus) => {
  if (cardType === 'ELITE') {
    return 'EARN 5% REWARDS';
  } else if (cardType === 'INTRO' && cardPaymentStatus) {
    return 'Upgrade Now @₹360';
  } else if (cardType === 'INTRO' && !cardPaymentStatus) {
    return 'Upgrade Now @₹499';
  } else if (cardType === 'NOCARD') {
    return 'Activate Now';
  }
  return 'UPGRADE TO ELITE';
};

/**
 * Calculate current day number from campaign start date
 * Returns day number (1-7) or null if campaign hasn't started or has ended
 */
export const getCurrentDayFromStartDate = (startDate) => {
  if (!startDate) return null;
  
  const start = new Date(startDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  start.setHours(0, 0, 0, 0);
  
  const diffTime = today - start;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
  
  // Return day number if between 1-7, otherwise null
  if (diffDays >= 1 && diffDays <= 7) {
    return diffDays;
  }
  
  return null;
};
